import React from 'react';
import { UsersIcon, SettingsIcon, BarChart2Icon, ShieldIcon } from 'lucide-react';
export function WhyUsSection() {
  // Function to handle navigation clicks with smooth scrolling
  const handleNavClick = sectionId => {
    // Prevent default anchor behavior
    event.preventDefault();
    // Get the target element to scroll to
    const targetElement = document.getElementById(sectionId);
    if (targetElement) {
      // Scroll smoothly to the element
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      // Update URL without page reload
      history.pushState(null, null, `#${sectionId}`);
    }
  };
  return <section id="why-us" className="py-20 bg-white" data-id="element-278">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-279">
        <div className="text-center mb-16" data-id="element-280">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900" data-id="element-281">
            Why Choose Us
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-282">
            We deliver measurable results that directly impact your bottom line
          </p>
        </div>
        <div className="grid md:grid-cols-4 gap-8" data-id="element-283">
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 transition-all duration-300 hover:shadow-md hover:-translate-y-1 group" data-id="element-284">
            <div className="w-14 h-14 rounded-full bg-navy-100 flex items-center justify-center mb-5 group-hover:bg-navy-200 transition-colors duration-300" data-id="element-285">
              <UsersIcon className="h-7 w-7 text-navy-800" data-id="element-286" />
            </div>
            <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-287">
              High-Paying Client Targeting
            </h3>
            <p className="text-gray-600" data-id="element-288">
              Attract premium clients ready to invest in your services
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 transition-all duration-300 hover:shadow-md hover:-translate-y-1 group" data-id="element-289">
            <div className="w-14 h-14 rounded-full bg-navy-100 flex items-center justify-center mb-5 group-hover:bg-navy-200 transition-colors duration-300" data-id="element-290">
              <SettingsIcon className="h-7 w-7 text-navy-800" data-id="element-291" />
            </div>
            <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-292">
              Done-For-You Campaigns
            </h3>
            <p className="text-gray-600" data-id="element-293">
              Complete setup and optimization without taking your time
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 transition-all duration-300 hover:shadow-md hover:-translate-y-1 group" data-id="element-294">
            <div className="w-14 h-14 rounded-full bg-navy-100 flex items-center justify-center mb-5 group-hover:bg-navy-200 transition-colors duration-300" data-id="element-295">
              <BarChart2Icon className="h-7 w-7 text-navy-800" data-id="element-296" />
            </div>
            <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-297">
              Clear Data Reporting
            </h3>
            <p className="text-gray-600" data-id="element-298">
              Full transparency on how your ad budget delivers results
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 transition-all duration-300 hover:shadow-md hover:-translate-y-1 group" data-id="element-299">
            <div className="w-14 h-14 rounded-full bg-navy-100 flex items-center justify-center mb-5 group-hover:bg-navy-200 transition-colors duration-300" data-id="element-300">
              <ShieldIcon className="h-7 w-7 text-navy-800" data-id="element-301" />
            </div>
            <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-302">
              No Long-Term Contracts
            </h3>
            <p className="text-gray-600" data-id="element-303">
              Our results keep you coming back, not binding agreements
            </p>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-304">
          <a href="#contact" className="inline-block px-8 py-4 rounded-md bg-navy-800 text-white font-bold text-lg hover:bg-navy-700 transition-all duration-300 hover:-translate-y-1" onClick={e => {
          e.preventDefault();
          handleNavClick('contact');
        }} data-id="element-305">
            See How We Can Help Your Business
          </a>
        </div>
      </div>
    </section>;
}